import { apiClient } from './client';

export function lookupAdmissionResult({ identification, captchaToken }) {
  return apiClient
    .post('/admission-results/lookup', { identification, captcha_token: captchaToken })
    .then((res) => res.data.data);
}

export function fetchResultNotice() {
  return apiClient.get('/admission-results/notice').then((res) => res.data.data);
}
